import React, { ReactNode } from 'react';
import { DndContext, closestCenter, PointerSensor, useSensor, useSensors, DragEndEvent } from '@dnd-kit/core';
import { arrayMove, SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { Item, ItemInterface } from './Item';

import './List.scss';

interface Props<T> {
  items: T[];
  setItems: (items: T[]) => void;
  parser: (item: T) => ReactNode;
}

export default function List<T extends ItemInterface>(props: Props<T>) {
  const { items, setItems, parser } = props;

  const sensors = useSensors(
    useSensor(PointerSensor),
  );

  const handleDragEnd = (event: DragEndEvent) => {
    const { active, over } = event;

    if (active.id !== over?.id) {
      const oldIndex = items.findIndex(item => item.id === active.id);
      const newIndex = items.findIndex(item => item.id === over?.id);
      const newItems = arrayMove(items, oldIndex, newIndex);
      setItems(newItems);
    }
  };

  return (
    <div className="sortable-list">
      <DndContext
        sensors={sensors}
        collisionDetection={closestCenter}
        onDragEnd={handleDragEnd}
      >
        <SortableContext
          items={items}
          strategy={verticalListSortingStrategy}
        >
          {
            items.map(item => (
              <Item key={item.id} id={item.id}>
                { parser(item) }
              </Item>
            ))
          }
        </SortableContext>
      </DndContext>
    </div>
  );
}
